import { UserService } from './User';
import { DepositService } from './Deposit';
import { TransferOptionsService } from './TransferOptions';
import { WithdrawService } from './Withdraw';
import { InternalTransferService } from './InternalTransfer';
import { DocumentService } from './DocumentService';
import { UniPaymentService } from './UniPayment';

export const Service = {
  User: UserService,
  Deposit: DepositService,
  TransferOptions: TransferOptionsService,
  Withdraw: WithdrawService,
  InternalTransfer: InternalTransferService,
  DocumentService,
  UniPayment: UniPaymentService,
};
